import React, { useCallback, useRef, useState } from "react";
import { notification, TableProps } from "antd";

import { IGerenciarSistemaContabilProps } from ".";

import { useGetColumnSearchProps } from "../../../../../../../../hooks/FilterTable/stringCLearFiltros";
import SolicitacoesDeAtivacaoService from "../../../../../../../../services/http/services/SaldoDeContas/SolicitacoesDeAtivacaoService";
import { EmitirErro } from "../../../../../../../../services/EmitirErro";

export const useGerenciarSistemaContabil = ({
    solicitacao,
    onUpdateSistema,
    requestUpdateSistema,
}: IGerenciarSistemaContabilProps) => {

    const refContagemDoFiltroTabelaModal = React.useRef<Array<any>>([]);
    const [modalDesvincularUserVisible, setModalDesvincularUserVisible] = useState(false);
    const [loadingTableModal, setLoadingTableModal] = useState(false);
    const [selectedRowKeysModal, setSelectedRowKeysModal] = useState<number[]>([]);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [dadosTabelaUsuariosModal, setDadosTabelaUsuariosModal] = useState<{
        id: number,
        nome: string,
        sistemas: Array<any>
    }>();

    const onClickEditarSistemaContabil = (): void => {
        setLoadingTableModal(true);
        const buscaDeDados = async () => {

            try {
                setModalDesvincularUserVisible(true);

                if (solicitacao.sistemaContabilId) {
                    setSelectedRowKeysModal([solicitacao.sistemaContabilId]);
                }

                const sistemasList = await SolicitacoesDeAtivacaoService.getSistemasContabeis();

                setDadosTabelaUsuariosModal({
                    id: solicitacao.contrato.id,
                    nome: solicitacao.contrato.nome,
                    sistemas: sistemasList,
                });

                setLoadingTableModal(false);
            } catch (error) {
                setLoadingTableModal(false);
                notification.error({
                    message: 'Erro',
                    description: `Não foi possivel buscar, entre em contato com suporte!`
                });
            }
        }

        buscaDeDados();
    }

    const clickCancelModalAddConfig = useCallback((): void => {
        setModalDesvincularUserVisible(false);
        setSelectedRowKeysModal([]);
        setDadosTabelaUsuariosModal(undefined);
    }, []);

    const refFuncaoLimparFiltrosStringNome = useRef<any>(null);
    const columnSearchPropsNome = useGetColumnSearchProps('nome', refFuncaoLimparFiltrosStringNome);

    const columnsModal = [
        {
            title: 'Sistema',
            dataIndex: 'nome',
            ...columnSearchPropsNome,
            width: '15%',
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo_integracao',
            ...columnSearchPropsNome,
            width: '9%',
        },
    ];

    const rowSelectionModal: TableProps<any>['rowSelection'] = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: Array<string>) => {
            setSelectedRowKeysModal(selectedRowKeys as number[])
        },
        getCheckboxProps: (record: any) => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
        selectedRowKeys: selectedRowKeysModal,
        columnWidth: '2%'
    };

    const onClickSave = useCallback(async () => {
        try {
            setIsSubmiting(true);

            const result = await requestUpdateSistema({
                solicitacaoId: solicitacao.id,
                sistemaContabilId: selectedRowKeysModal[0],
            });

            if (!result) {
                return;
            }

            onUpdateSistema(result);

            setIsSubmiting(false);
            setModalDesvincularUserVisible(false);
            setSelectedRowKeysModal([]);
            setDadosTabelaUsuariosModal(undefined);

            notification.success({
                message: 'Sucesso',
                description:
                    'Sistema contábil alterado com sucesso!',
            });
        } catch (error) {
            EmitirErro(error, true, "saveSistemaContabilSolicitacao_90asdas0idan0sd0inas");
            setIsSubmiting(false);
        }
    }, [selectedRowKeysModal]);

    return {
        modalDesvincularUserVisible,
        clickCancelModalAddConfig,
        loadingTableModal,
        dadosTabelaUsuariosModal,
        columnsModal,
        refContagemDoFiltroTabelaModal,
        onClickEditarSistemaContabil,
        rowSelectionModal,
        onClickSave,
        isSubmiting,
    }
}
